const URL = "https://iot.kpu.krosno.pl:8082/api/";
export default URL;